import { supabase } from '../supabase';

export interface TestConfig {
  testType: 'full' | 'partial';
  selectedSubjects: string[];
  questionTypes: string[];
  duration: number;
  questionCount: number;
  paperName: string;
  exam: string;
}

export const generateCustomTest = async (config: TestConfig) => {
  try {
    const functionName = config.exam === 'NDA' ? 'get_random_nda_questions' : 'get_random_jeemain_questions';

    const typeFilters = [];
    if (config.questionTypes.includes('multiple-choice')) {
      typeFilters.push('Single Correct');
    }
    if (config.questionTypes.includes('integer')) {
      typeFilters.push('Integer');
    }

    const rpcParams = {
      p_subjects: config.selectedSubjects,
      p_question_types: typeFilters,
      p_paper_name: config.paperName,
      p_question_count: config.questionCount
    };

    if (config.testType === 'full') {
      rpcParams.p_subjects = null;
      rpcParams.p_question_types = null;
    }

    console.log('Calling Supabase RPC function:', functionName, rpcParams);

    const { data: questions, error } = await supabase.rpc(functionName, rpcParams);

    if (error) throw error;

    if (!questions || questions.length === 0) {
      throw new Error('No questions found matching the criteria');
    }

    const selectedQuestions = questions;
    
    // Format questions for test
    const formattedQuestions = selectedQuestions.map(q => ({
      id: q.id.toString(),
      text: q.question,
      options: q.type === 'Integer' ? [] : [q.option1, q.option2, q.option3, q.option4].filter(opt => opt),
      answer: q.type === 'Integer' ? q.correct : q[q.correct],
      solution: q.explanation,
      subject: q.subject || 'General',
      topic: q.tags || 'Unknown Topic',
      difficulty: getDifficultyFromLevel(q.level),
      type: q.type || 'Single Choice'
    }));
    
    // Create test object
    const test = {
      id: `custom_${Date.now()}`,
      name: `${config.paperName} - Custom Test`,
      exam: config.exam,
      duration: config.duration,
      totalMarks: formattedQuestions.length * 4,
      negativeMarks: 1,
      questions: formattedQuestions,
      config
    };
    
    return test;
  } catch (error) {
    console.error('Error generating custom test:', error);
    throw error;
  }
};

const getDifficultyFromLevel = (level: number) => {
  switch (level) {
    case 1: return 'Easy';
    case 2: return 'Medium';
    case 3: return 'Hard';
    default: return 'Medium';
  }
};